var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.77 114.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4 {\r\n        fill: none;\r\n        stroke: #cdaa69;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-4 {\r\n        stroke-width: .25px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-dasharray: 0 0 1.5 1;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke-width: .75px;\r\n      }\r\n\r\n      .cls-4 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.89,9.79c26.2,0,47.45,21.25,47.45,47.45s-21.25,47.45-47.45,47.45S3.43,83.44,3.43,57.24,24.68,9.79,50.89,9.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.89 9.81 71.43 21.66 91.96 33.52 91.96 57.24 91.96 80.96 71.43 92.81 50.89 104.67 30.35 92.81 9.81 80.96 9.81 57.24 9.81 33.52 30.35 21.66 50.89 9.81"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 50.89,
    cy: 104.67,
    r: 9.68
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.58,76.12c2.67-4.63,8.6-6.22,13.22-3.54,4.63,2.67,6.22,8.6,3.54,13.22-2.67,4.63-8.6,6.22-13.22,3.54-4.63-2.67-6.22-8.6-3.54-13.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.58,38.36c-2.67-4.63-1.09-10.55,3.54-13.23,4.63-2.67,10.55-1.09,13.22,3.54,2.67,4.63,1.09,10.55-3.54,13.22-4.63,2.67-10.55,1.09-13.22-3.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.89,19.49c-5.35,0-9.68-4.34-9.68-9.68S45.54,.12,50.89,.12s9.68,4.34,9.68,9.68-4.34,9.68-9.68,9.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.19,38.36c-2.67,4.63-8.6,6.22-13.22,3.54C.34,39.23-1.25,33.31,1.42,28.68c2.67-4.63,8.6-6.22,13.22-3.54,4.63,2.67,6.22,8.6,3.54,13.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M18.19,76.12c2.67,4.63,1.09,10.55-3.54,13.22-4.63,2.67-10.55,1.09-13.22-3.54-2.67-4.63-1.09-10.55,3.54-13.22,4.63-2.67,10.55-1.09,13.22,3.54Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50.89 9.81 71.43 45.38 91.96 80.96 50.89 80.96 9.81 80.96 30.35 45.38 50.89 9.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "50.89 104.67 71.43 69.1 91.96 33.52 50.89 33.52 9.81 33.52 30.35 69.1 50.89 104.67"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.89,
    cy: 57.24,
    r: 23.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.89,47.06c5.62,0,10.18,4.56,10.18,10.18s-4.56,10.18-10.18,10.18-10.18-4.56-10.18-10.18,4.56-10.18,10.18-10.18Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.89,
    cy: 47.06,
    r: 10.18,
    transform: "translate(-.44 93.64) rotate(-84.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.51,47.06c2.81,4.87,1.14,11.09-3.73,13.9-4.87,2.81-11.09,1.14-13.9-3.73-2.81-4.87-1.14-11.09,3.73-13.9,4.87-2.81,11.09-1.14,13.9,3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.51,67.42c-2.81,4.87-9.04,6.54-13.9,3.73-4.87-2.81-6.54-9.04-3.73-13.9,2.81-4.87,9.04-6.54,13.9-3.73,4.87,2.81,6.54,9.04,3.73,13.9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 50.89,
    cy: 67.42,
    r: 10.18,
    transform: "translate(-24.79 104.93) rotate(-79.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.26,67.42c-2.81-4.87-1.14-11.09,3.73-13.9,4.87-2.81,11.09-1.14,13.9,3.73,2.81,4.87,1.14,11.09-3.73,13.9-4.87,2.81-11.09,1.14-13.9-3.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.26,47.06c2.81-4.87,9.04-6.54,13.9-3.73,4.87,2.81,6.54,9.04,3.73,13.9-2.81,4.87-9.04,6.54-13.9,3.73-4.87-2.81-6.54-9.04-3.73-13.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M9.81,34.64c-.61,0-1.11-.5-1.11-1.11,0-.61,.5-1.11,1.11-1.11,.61,0,1.11,.5,1.11,1.11,0,.61-.5,1.11-1.11,1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.92,10.36c-.31-.53-.12-1.21,.41-1.52,.53-.31,1.21-.12,1.52,.41,.31,.53,.12,1.21-.41,1.52-.53,.31-1.21,.13-1.52-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91,32.97c.31-.53,.99-.71,1.52-.41,.53,.31,.71,.99,.41,1.52-.31,.53-.99,.71-1.52,.41-.53-.31-.71-.99-.41-1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M91.96,79.84c.61,0,1.11,.5,1.11,1.11,0,.61-.5,1.11-1.11,1.11-.61,0-1.11-.5-1.11-1.11,0-.61,.5-1.11,1.11-1.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M51.85,104.12c.31,.53,.12,1.21-.41,1.52-.53,.31-1.21,.12-1.52-.41-.31-.53-.12-1.21,.41-1.52,.53-.31,1.21-.12,1.52,.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.77,81.51c-.31,.53-.99,.71-1.52,.41-.53-.31-.71-.99-.41-1.52,.31-.53,.99-.71,1.52-.41,.53,.31,.71,.99,.41,1.52Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem4);
export default __webpack_public_path__ + "static/media/item4.70f78041dc2a9a51c036314f5e024913.svg";
export { ForwardRef as ReactComponent };